const lib = {
	selectors: {
		tileCtr: '.customer__tiles',
		tile: '.tile',
	},
};

const showEl = (el) => (el.hidden = false);
const hideEl = (el) => (el.hidden = true);

document.addEventListener('mcflyFilterChange', function (event) {
	const tileContainer = document.querySelector(lib.selectors.tileCtr);
	const allTiles = tileContainer.querySelectorAll(lib.selectors.tile);

	allTiles.forEach((tile) => {
		if (!event.detail.filterValue) {
			showEl(tile);
		} else {
			const tileCategories = tile.getAttribute('data-cat').split(' ');
			if (!tileCategories.includes(event.detail.filterValue)) {
				hideEl(tile);
			} else {
				showEl(tile);
			}
		}
	});

	if (Array.from(allTiles).filter((tile) => !tile.hidden).length === 0) {
		hideEl(tileContainer);
	} else {
		showEl(tileContainer);
	}
});
